import axios from 'lib/axios'

export const loadCompanies = function (params = {}) {
  return axios.get('/super/api/companies', { params })
}

export const loadCompany = function (id) {
  return axios.get(`/super/api/companies/${id}`)
}

export const createCompany = function (params) {
  return axios.post('/super/api/companies', params)
}

export const updateCompany = function (params, id) {
  return axios.patch(`/super/api/companies/${id}`, params)
}

export const loadCompanyRequests = function (params = {}) {
  return axios.get(`/super/api/company_requests`, { params })
}

export const confirmCompanyRequest = function (id) {
  return axios.patch(`/super/api/company_requests/${id}/confirm`)
}

export const mergeCompanyRequest = function (params, id) {
  return axios.post(`/super/api/company_requests/${id}/merge`, params)
}

export const rejectCompanyRequest = function (request_id) {
  return axios.patch(`/super/api/company_requests/${request_id}/reject`)
}
